import revive_payload_client_4sVQNw7RlN from "/home/forge/oase-aej.de/releases/82168262/client/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/forge/oase-aej.de/releases/82168262/client/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/forge/oase-aej.de/releases/82168262/client/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/forge/oase-aej.de/releases/82168262/client/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/forge/oase-aej.de/releases/82168262/client/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/forge/oase-aej.de/releases/82168262/client/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/forge/oase-aej.de/releases/82168262/client/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/home/forge/oase-aej.de/releases/82168262/client/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/forge/oase-aej.de/releases/82168262/client/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/forge/oase-aej.de/releases/82168262/client/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_U4BUIcs89R from "/home/forge/oase-aej.de/releases/82168262/client/node_modules/nuxt-graphql-client/dist/runtime/plugin.js";
import plugin_WLsn00x1qh from "/home/forge/oase-aej.de/releases/82168262/client/node_modules/@nuxt/icon/dist/runtime/plugin.js";
import plugin_8SbxDRbG6Y from "/home/forge/oase-aej.de/releases/82168262/client/node_modules/dayjs-nuxt/dist/runtime/plugin.mjs";
import switch_locale_path_ssr_5csfIgkrBP from "/home/forge/oase-aej.de/releases/82168262/client/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/home/forge/oase-aej.de/releases/82168262/client/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import matomo_client_hZHcd59ZPU from "/home/forge/oase-aej.de/releases/82168262/client/plugins/matomo.client.js";
import auth_vT9JWWT9pN from "/home/forge/oase-aej.de/releases/82168262/client/plugins/auth.ts";
import casl_7eGVIGiOQa from "/home/forge/oase-aej.de/releases/82168262/client/plugins/casl.js";
import caslStorePlugin_2XZOpv0jMH from "/home/forge/oase-aej.de/releases/82168262/client/plugins/caslStorePlugin.ts";
import chartjs_QHNNJeVECT from "/home/forge/oase-aej.de/releases/82168262/client/plugins/chartjs.js";
import draggableGrid_LQ566v7JXI from "/home/forge/oase-aej.de/releases/82168262/client/plugins/draggableGrid.js";
import error_handler_VFH3VvK7yG from "/home/forge/oase-aej.de/releases/82168262/client/plugins/error-handler.js";
import farbcode_core_rz2AqV8wmd from "/home/forge/oase-aej.de/releases/82168262/client/plugins/farbcode-core.js";
import flare_client_8OewLYGJqN from "/home/forge/oase-aej.de/releases/82168262/client/plugins/flare.client.ts";
import v_maska_ukW5YL2KMQ from "/home/forge/oase-aej.de/releases/82168262/client/plugins/v-maska.js";
import vee_validate_K3WwmJMPDb from "/home/forge/oase-aej.de/releases/82168262/client/plugins/vee-validate.js";
import vue_qrcode_38KrEZ5k5d from "/home/forge/oase-aej.de/releases/82168262/client/plugins/vue-qrcode.js";
import vue_signature_pad_aAdMfaZHaE from "/home/forge/oase-aej.de/releases/82168262/client/plugins/vue-signature-pad.js";
import ziggy_861J4JMJOx from "/home/forge/oase-aej.de/releases/82168262/client/plugins/ziggy.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_U4BUIcs89R,
  plugin_WLsn00x1qh,
  plugin_8SbxDRbG6Y,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  matomo_client_hZHcd59ZPU,
  auth_vT9JWWT9pN,
  casl_7eGVIGiOQa,
  caslStorePlugin_2XZOpv0jMH,
  chartjs_QHNNJeVECT,
  draggableGrid_LQ566v7JXI,
  error_handler_VFH3VvK7yG,
  farbcode_core_rz2AqV8wmd,
  flare_client_8OewLYGJqN,
  v_maska_ukW5YL2KMQ,
  vee_validate_K3WwmJMPDb,
  vue_qrcode_38KrEZ5k5d,
  vue_signature_pad_aAdMfaZHaE,
  ziggy_861J4JMJOx
]